module.exports = __webpack_public_path__ + "static/media/bjh.4d30d235.svg";